"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOGIN_CHANGE_LOGIN_TYPE = void 0;
const LOGIN_CHANGE_LOGIN_TYPE = exports.LOGIN_CHANGE_LOGIN_TYPE = 'login/changeLogin';